export function toTop() {
  // 动画

  let timer = setInterval(function() {
    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
    let ispeed = Math.floor(-osTop / 5);
    document.documentElement.scrollTop = document.body.scrollTop =
      osTop + ispeed;
    this.isTop = true;
    if (osTop === 0) {
      clearInterval(timer);
    }
  }, 10);
}

import request from "@/utils/request.js";

export default {
  getMoreText(text, len) {
    if (text != null) {
      if (text.length > len) {
        // return text.substring(0,5) + "..." + text.substring(text.length - 6,text.length -1);
        return text.substring(0, len) + "...";
      }
    }
    return text;
  },
  getSpaceText(text) {
    if (text != null) {
      if (text.length > 15) {
        return (
          text.substring(0, 15) +
          "..." +
          text.substring(text.length - 16, text.length - 1)
        );
      }
    }
    return text;
  },
  openPic(pic) {
    if (pic === "" || pic === undefined || pic == null) {
      return;
    }
    window.open(pic, "_blank");
  },
  isEmpty(value) {
    return value === undefined || value == null || value === "";
  },
  async putFile(file, loading) {
    let formDate = new FormData();
    formDate.append("file", file);
    let data = await request.post("/file/putFile", formDate).catch(res => {
      this.$message.error(res.message);
      loading = false;
    });
    console.log(data);
    if (data.code === 200) {
      return data.data;
    } else {
      this.$message.error(data.msg);
      loading = false;
      return null;
    }
  },
  async putFileBig(file, loading, load) {
    let formDate = new FormData();
    formDate.append("file", file);
    let data = await request.post("/file/putFileBig", formDate).catch(res => {
      this.$message.error("上传文件失败");
      loading = false;
      load.close();
    });
    console.log(data);
    if (data.code === 200) {
      return data.data;
    } else {
      this.$message.error(data.msg);
      loading = false;
      load.close();
      return null;
    }
  },
  async putFiles(fileList, loading) {
    let formDate = new FormData();
    fileList.forEach(file => {
      formDate.append("file", file);
    });
    let data = await request.post("/file/uploadFiles", formDate).catch(res => {
      this.$message.error(res.data.msg);
      loading = false;
    });
    if (data.code === 200) {
      let result = data.data;
      let img = [];
      result.forEach(item => {
        img.push(item);
      });
      return img;
    } else {
      this.$message.error(data.msg);
      loading = false;
      return null;
    }
  },

  httpRequest(data) {},

  getTypeName(typeList, id) {
    for (let i = 0; i < typeList.length; i++) {
      let item = typeList[i];

      if (item.id === id) {
        return item.name;
      }
    }
  },

  formatSeconds(value) {
    let secondTime = parseInt(value); // 秒
    let minuteTime = 0; // 分
    let hourTime = 0; // 小时
    if (secondTime >= 60) {
      minuteTime = parseInt(secondTime / 60);
      secondTime = parseInt(secondTime % 60);
      if (minuteTime >= 60) {
        hourTime = parseInt(minuteTime / 60);
        minuteTime = parseInt(minuteTime % 60);
      }
    }
    return {
      second: parseInt(secondTime), // 秒
      minute: parseInt(minuteTime), // 分
      hour: parseInt(hourTime)
    };
  },

  formatMinute(value) {
    let secondTime = parseInt(value); // 秒
    let minuteTime = 0; // 分
    if (secondTime >= 60) {
      minuteTime = parseInt(secondTime / 60);
      secondTime = parseInt(secondTime % 60);
    }

    let second = parseInt(secondTime);
    let minute = parseInt(minuteTime);
    if (second < 10) {
      second = "0" + second;
    }
    if (minute < 10) {
      minute = "0" + minute;
    }

    return minute + "分" + second + "秒";
  },

  formatMins(value) {
    let minuteTime = parseInt(value); // 分
    let hourTime = 0; // 小时
    if (minuteTime >= 60) {
      hourTime = parseInt(minuteTime / 60);
      minuteTime = parseInt(minuteTime % 60);
    }
    return {
      minute: parseInt(minuteTime), // 分
      hour: parseInt(hourTime)
    };
  },

  getPickerOptions() {
    return {
      disabledDate(time) {
        let _now = Date.now();
        return time.getTime() > _now;
        //大于当前的禁止，小于7天前的禁止
      },
      shortcuts: [
        {
          text: "近7日",
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          text: "近30日",
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }
      ]
    };
  },

  getTianKong(str) {
    if (this.isEmpty(str)) return "";
    return JSON.parse(str).join("、");
  }
};



// WEBPACK FOOTER //
// ./src/utils/util.js